<template>
  <div :class="componentClassName">
    <a-page-heading>電話番号管理 </a-page-heading>
    <m-section>
      <m-action-card id="numberMgmt" :title="`電話番号管理 （${numberList.length}）`" icon="user-setting">
        <m-form-input>
          <a-select-field
            id="serviceList"
            v-model="selectedService"
            :options="serviceList"
            @change="handlerGetNumberInfo(true)"
          />
          <!-- <a-button
            :inline="true"
            variant="fill"
            color="primary"
            size="medium"
            label="表示"
            @click="handlerGetNumberInfo(true)"
          /> -->
          <a-text-field
            id="search_field"
            v-model="searchPhonenumber"
            type="search"
            placeholder="050番号"
            :maxlength="selMaxLength"
          />
          <a-button
            id="search_btn"
            :inline="true"
            variant="fill"
            color="primary"
            size="medium"
            label="検索"
            icon="search"
            icon-color="white"
            style="margin-right: 4px"
            @click="handleSearchPhonenumberClick()"
          />
          <a-button
            v-if="canDownloadCSV"
            id="downloadCSVBtn"
            :inline="true"
            variant="fill"
            color="primary"
            size="medium"
            label="CSVダウンロード"
            icon="download"
            icon-color="white"
            @click="handleDownloadClick()"
          />
        </m-form-input>
        <br /><br />
        <m-data-table ref="dataTable" :empty-text="dataTableEmptyText" :fit="true" :data="numberList">
          <a-data-table-column prop="numberView" :min-width="80" label="電話番号" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('numberView', 'asc')"
                :handle-sort-descending="() => handleSort('numberView', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="companyID" :min-width="60" label="契約ID" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('companyID', 'asc')"
                :handle-sort-descending="() => handleSort('companyID', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="adminName" :min-width="80" label="契約者氏名" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminName', 'asc')"
                :handle-sort-descending="() => handleSort('adminName', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="customerFDNDNumberView"
            :min-width="80"
            label="FD/ND番号"
            align="center"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('customerFDNDNumberView', 'asc')"
                :handle-sort-descending="() => handleSort('customerFDNDNumberView', 'desc')"
              />
            </template>
            <template #default="scope">
              <a-text :text="scope.row.customerFDNDNumberView"></a-text>
              <div v-if="checkFdndNumberEditStatus(scope.row.customerFDNDType, scope.row.customerFDNDStatus)">
                <a-button
                  v-if="canEditFDNDNumber"
                  :id="`editFDNDNumberBtn${scope.row.numberView}`"
                  :inline="true"
                  variant="round"
                  color="grey"
                  size="small"
                  icon="edit"
                  label="編集"
                  @click="
                    openFdndEditView(scope.row.customerFDNDNumber);
                    currentFdndNumber = scope.row.customerFDNDNumber;
                    currentEditContentNumber = scope.row.number;
                    currentEditCompanyID = scope.row.companyID;
                    previousFdndNumber = scope.row.customerFDNDNumber;
                    currentEditFdndType = scope.row.customerFDNDType;
                  "
                />
              </div>
            </template>
          </a-data-table-column>
          <a-data-table-column :min-width="80" label="050番号<br>ステータス" align="center" :filterable="true">
            <template #default="scope">
              <a-button
                :id="`number050Status${scope.row.numberView}`"
                variant="text"
                size="medium"
                :label="scope.row.statusName"
                color="primary"
                :disabled="
                  !['allocated', 'suspended'].includes(scope.row.status) ||
                  !canSuspendOrReactive050Number(scope.row.companyID)
                "
                @click="
                  if (scope.row.status === 'allocated') {
                    suspend050NumberModal = {
                      visible: true,
                      companyID: scope.row.companyID,
                      selected050Number: scope.row.numberView,
                      step: 1,
                    };
                  }
                  if (scope.row.status === 'suspended') {
                    reactive050NumberModal = {
                      visible: true,
                      companyID: scope.row.companyID,
                      selected050Number: scope.row.numberView,
                      step: 1,
                    };
                  }
                "
              />
            </template>
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                ref="statusFilter"
                variant="filter"
                :data-list="statusFilterDataList"
                :selected-items="checkedStatus"
                :handle-filter-cancel="() => handleFilterCancel('statusName')"
                :handle-filter-confirm="data => handleFilterConfirm('statusName', data, 0)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column :min-width="80" label="利用停止日" prop="suspendedDateStr" align="center" />
          <a-data-table-column
            prop="updateDate"
            :min-width="80"
            label="050番号<br>ステータス更新日"
            align="center"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                variant="sort-time"
                :handle-sort-ascending="() => handleSort('updateDate', 'asc')"
                :handle-sort-descending="() => handleSort('updateDate', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="customerFDNDStatusName"
            :min-width="80"
            label="FD/ND番号<br>ステータス"
            align="center"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                ref="statusFilterFdnd"
                variant="filter"
                :data-list="fdndStatusFilterDataList"
                :selected-items="checkedStatusFdnd"
                :handle-filter-cancel="() => handleFilterCancel('customerFDNDStatusName')"
                :handle-filter-confirm="data => handleFilterConfirm('customerFDNDStatusName', data, 0)"
              />
            </template>
            <template #default="scope">
              <a-button
                :id="`fdndStatusBtn${scope.row.numberView}`"
                variant="text"
                size="medium"
                :label="scope.row.customerFDNDStatusName"
                color="primary"
                :disabled="scope.row.customerFDNDStatus === 'unavailable' || !canOperateFDNDNumberStatus"
                @click="handleChangeFdndStatus(scope.row)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="customerFDNDUpdateDate"
            :min-width="80"
            label="FD/ND番号<br>ステータス更新日"
            align="center"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                variant="sort-time"
                :handle-sort-ascending="() => handleSort('customerFDNDUpdateDate', 'asc')"
                :handle-sort-descending="() => handleSort('customerFDNDUpdateDate', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column :min-width="80" label="備考" align="center">
            <template #default="scope">
              <a-text :text="scope.row.noteView"></a-text>
              <a-button
                v-if="canEditRemarks"
                :id="`editRemarksBtn${scope.row.numberView}`"
                :inline="true"
                variant="round"
                color="grey"
                size="small"
                icon="edit"
                label="編集"
                @click="
                  noteVisible = true;
                  currentNote = scope.row.note;
                  currentEditContentNumber = scope.row.number;
                  currentEditCompanyID = scope.row.companyID;
                "
              />
            </template>
          </a-data-table-column>
        </m-data-table>
        <a-text v-if="isLoadingNumberList">読み込み中...</a-text>
      </m-action-card>
    </m-section>
  </div>

  <!-- FD/ND番号入力画面 -->
  <teleport to="body">
    <!-- 新規登録の場合 -->
    <o-modal
      v-if="fdndEditViewMode === 'new'"
      id="fdndCreateNewModal"
      :visible="fdndVisible"
      v-bind="$props"
      :close-on-click-modal="false"
      @close="handleCloseFdndEdit"
    >
      <template #title>FD/ND番号の新規登録</template>
      <a-text color="orange" :center="true">
        契約ID: {{ currentEditCompanyID }}<br />
        050番号: {{ currentEditContentNumber.replace('+81', '0') }}<br /><br />
      </a-text>
      <a-text :center="true">上記050番号と紐付けするFD/ND番号を入力してください。<br /><br /></a-text>
      <a-text-field v-model="currentFdndNumber" type="textarea" placeholder="FD/ND番号" />
      <template #footer>
        <a-button
          id="fdndEditModalSaveBtn"
          variant="block"
          color="primary"
          label="保存"
          size="small"
          @click="handleEditFdndNumberClick(currentEditContentNumber, currentEditCompanyID, currentEditFdndType)"
        />
        <a-button
          id="fdndEditModalCloseBtn"
          variant="outlined"
          color="primary"
          label="閉じる"
          size="small"
          @click="handleCloseFdndEdit"
        />
      </template>
    </o-modal>
    <!-- 既存データがある場合 -->
    <o-modal
      v-if="fdndEditViewMode === 'edit'"
      id="fdndEditModal"
      :visible="fdndVisible"
      v-bind="$props"
      :close-on-click-modal="false"
      @close="handleCloseFdndEdit"
    >
      <template #title>FD/ND番号の編集・削除</template>
      <a-text color="orange" :center="true">
        契約ID: {{ currentEditCompanyID }}<br />
        050番号: {{ currentEditContentNumber.replace('+81', '0') }}<br /><br />
      </a-text>
      <a-text :center="true">上記050番号と紐付けするFD/ND番号を入力してください。<br /><br /></a-text>
      <a-text :center="true" color="red">
        <p>※注意！</p>
        <p>
          登録済FDNDを誤って登録してしまった場合にこちらで再登録を行ってください（廃止新設の場合は、ステータス「利用中」のリンクから廃止処理を行ってください
        </p>
      </a-text>
      <a-text-field id="currentFdndNumber" v-model="currentFdndNumber" type="textarea" placeholder="FD/ND番号" />
      <template #footer>
        <a-button
          id="fdndEditModal2SaveBtn"
          variant="block"
          color="primary"
          label="保存"
          size="small"
          @click="handleEditFdndNumberClick(currentEditContentNumber, currentEditCompanyID, currentEditFdndType)"
        />
        <a-button
          id="fdndEditModal2CloseBtn"
          variant="outlined"
          color="primary"
          label="閉じる"
          size="small"
          @click="handleCloseFdndEdit"
        />
      </template>
    </o-modal>
    <!-- 完了メッセージ -->
    <o-modal
      v-if="fdndEditViewMode === 'completed'"
      id="fdndCompleteModal"
      :visible="fdndVisible"
      v-bind="$props"
      :close-on-click-modal="false"
      @close="handleCloseFdndEdit"
    >
      <template #title>FD/ND番号登録</template>
      <a-text color="orange" :center="true">
        契約ID: {{ currentEditCompanyID }}<br />
        FDND番号: {{ currentFdndNumber }}<br /><br />
      </a-text>
      <a-text :center="true">上記の通り番号登録を実施しました。<br /><br /></a-text>
      <template #footer>
        <a-button
          id="fdndEditModal3CloseBtn"
          variant="outlined"
          color="primary"
          label="閉じる"
          size="small"
          @click="handleCloseFdndEdit"
        />
      </template>
    </o-modal>
  </teleport>

  <!-- 備考入力画面 -->
  <teleport to="body">
    <o-modal
      id="editContentNumberModal"
      :visible="noteVisible"
      v-bind="$props"
      :close-on-click-modal="false"
      @close="handleCloseNoteEdit"
    >
      <template #title>備考を編集</template>
      <a-text>
        契約ID: {{ currentEditCompanyID }}<br />
        電話番号: {{ currentEditContentNumber.replace('+81', '0') }}<br /><br />
      </a-text>
      <a-text-field id="currentNote" v-model="currentNote" type="textarea" placeholder="備考" />
      <template #footer>
        <a-button
          id="editRemarksModalSaveBtn"
          variant="block"
          color="primary"
          label="保存"
          size="small"
          @click="handleEditNoteClick(currentEditContentNumber)"
        />
        <a-button
          id="editRemarksModalCancelBtn"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          @click="handleCloseNoteEdit"
        />
      </template>
    </o-modal>
  </teleport>

  <!-- モーダル -->
  <teleport to="body">
    <o-modal
      id="numberMgmt_resultModal"
      :visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="resultModalCloseBtn"
          variant="block"
          color="primary"
          label="閉じる"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
  <!-- 申し込み処理中　モーダル -->
  <teleport to="body">
    <o-modal
      id="numberMgmt_soProcessingModal"
      :visible="soProcessingModal.visible"
      class="o-modal-remove-phone-number-confirmation t-number-mgmt"
      footer-variant="confirmation"
      width="395px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>
        <a-text color="orange" :center="true">
          <p>契約ID：{{ soProcessingModal.data.companyID }}</p>
          <p>電話番号：{{ soProcessingModal.data.customerFDNDNumberView }}</p>
        </a-text>
      </template>
      <div v-if="soProcessingModal.screen === 1">
        <div class="a-modal-footer a-modal-footer--confirmation o-modal__footer">
          <div class="m-button-container m-button-container--horizontal">
            <a-button
              id="registeringModalCSVDownloadBtn"
              variant="block"
              color="primary"
              label="FDND申し込み内容ファイルダウンロード"
              size="small"
              style="width: 180px"
              @click="bzPortCsvDownload()"
            />
          </div>
        </div>
        <a-text :center="true">
          <p>申し込み処理を完了する場合は開通ボタンを押下し処理を完了させてください。</p>
        </a-text>
        <div class="a-modal-footer a-modal-footer--confirmation o-modal__footer">
          <div class="m-button-container m-button-container--horizontal">
            <a-button
              id="registeringModalApproveBtn"
              variant="block"
              color="primary"
              label="開通"
              size="small"
              :disabled="!soProcessingModal.csvDownloaded"
              @click="soProcessingModal.screen = 2"
            />
          </div>
        </div>
        <a-text :center="true">
          <p>SOキャンセル対象の場合はSOキャンセルボタンを押下しキャンセルしてください。</p>
        </a-text>
        <div class="a-modal-footer a-modal-footer--confirmation o-modal__footer">
          <div class="m-button-container m-button-container--horizontal">
            <a-button
              id="registeringModalSOCancelBtn"
              variant="block"
              color="primary"
              label="SOキャンセル"
              size="small"
              @click="soProcessingModal.screen = 4"
            />
          </div>
        </div>
      </div>
      <div v-if="soProcessingModal.screen === 2">
        <a-text :center="true">
          <p>上記番号が開通完了対象番号であることを確認してください。</p>
        </a-text>
      </div>
      <div v-if="soProcessingModal.screen === 3">
        <a-text :center="true">
          <p>上記FDND番号の開通登録を実施しました。</p>
        </a-text>
      </div>
      <div v-if="soProcessingModal.screen === 4">
        <a-text :center="true">
          <p>上記番号がキャンセル対象番号であることを確認してください。</p>
        </a-text>
      </div>
      <div v-if="soProcessingModal.screen === 5">
        <a-text :center="true">
          <p>上記番号がキャンセル対象番号であることを確認してください。</p>
        </a-text>
        <a-text :center="true" color="red">
          <p>※注意！</p>
          <p>対象のFDND番号に対してお客様からSOキャンセル依頼があったことを再度ご確認ください</p>
        </a-text>
      </div>
      <div v-if="soProcessingModal.screen === 6">
        <a-text :center="true">
          <p>上記FDND番号の新規SOキャンセルを実施しました。</p>
        </a-text>
      </div>
      <template #footer>
        <a-button
          v-if="soProcessingModal.screen === 2"
          id="registeringModalScreen2ApproveBtn"
          variant="block"
          color="primary"
          label="開通"
          size="small"
          :disabled="isLoading"
          @click="approveApplication()"
        />
        <a-button
          v-if="soProcessingModal.screen === 4"
          id="registeringModalScreen4SOCancelBtn"
          variant="block"
          color="primary"
          label="SOキャンセル"
          size="small"
          :disabled="isLoading"
          @click="soProcessingModal.screen = 5"
        />
        <a-button
          v-if="soProcessingModal.screen === 5"
          id="registeringModalScreen5SOCancelBtn"
          variant="block"
          color="primary"
          label="SOキャンセル"
          size="small"
          :disabled="isLoading"
          @click="cancelApplication()"
        />
        <a-button
          id="registeringModalCloseBtn"
          variant="outlined"
          color="primary"
          label="閉じる"
          size="small"
          :disabled="isLoading"
          @click="soProcessingModal.visible = false"
        />
      </template>
    </o-modal>
  </teleport>
  <!-- 廃止処理中　モーダル -->
  <teleport to="body">
    <o-modal
      id="numberMgmt_cancelSoProcessingModal"
      :visible="cancelSoProcessingModal.visible"
      class="o-modal-remove-phone-number-confirmation t-number-mgmt"
      footer-variant="confirmation"
      width="395px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>
        <a-text color="orange" :center="true">
          <p>契約ID：{{ cancelSoProcessingModal.data.companyID }}</p>
          <p>電話番号：{{ cancelSoProcessingModal.data.customerFDNDNumberView }}</p>
        </a-text>
      </template>
      <div v-if="cancelSoProcessingModal.screen === 1">
        <div class="a-modal-footer a-modal-footer--confirmation o-modal__footer">
          <div class="m-button-container m-button-container--horizontal">
            <a-button
              id="cancellingModalCSVDownloadBtn"
              variant="block"
              color="primary"
              label="FDND申し込み内容ファイルダウンロード"
              size="small"
              style="width: 180px"
              @click="cancelBzPortCsvDownload()"
            />
          </div>
        </div>
        <a-text :center="true">
          <p>廃止処理を完了する場合は廃止ボタンを押下し処理を完了させてください。</p>
        </a-text>
        <div class="a-modal-footer a-modal-footer--confirmation o-modal__footer">
          <div class="m-button-container m-button-container--horizontal">
            <a-button
              id="cancellingModalApproveBtn"
              variant="block"
              color="primary"
              label="廃止"
              size="small"
              :disabled="!cancelSoProcessingModal.csvDownloaded"
              @click="cancelSoProcessingModal.screen = 2"
            />
          </div>
        </div>
        <a-text :center="true">
          <p>SOキャンセル対象の場合はSOキャンセルボタンを押下しキャンセルしてください。</p>
        </a-text>
        <div class="a-modal-footer a-modal-footer--confirmation o-modal__footer">
          <div class="m-button-container m-button-container--horizontal">
            <a-button
              id="cancellingModalSOCancelBtn"
              variant="block"
              color="primary"
              label="SOキャンセル"
              size="small"
              @click="cancelSoProcessingModal.screen = 4"
            />
          </div>
        </div>
      </div>
      <div v-if="cancelSoProcessingModal.screen === 2">
        <a-text :center="true">
          <p>上記番号が廃止完了対象番号であることを確認してください。</p>
        </a-text>
      </div>
      <div v-if="cancelSoProcessingModal.screen === 3">
        <a-text :center="true">
          <p>上記FDND番号の廃止登録を実施しました。</p>
        </a-text>
      </div>
      <div v-if="cancelSoProcessingModal.screen === 4">
        <a-text :center="true">
          <p>上記番号がキャンセル対象番号であることを確認してください。</p>
        </a-text>
      </div>
      <div v-if="cancelSoProcessingModal.screen === 5">
        <a-text :center="true">
          <p>上記番号がキャンセル対象番号であることを確認してください。</p>
        </a-text>
        <a-text :center="true" color="red">
          <p>※注意！</p>
          <p>
            キャンセル対象の050番号が廃止済の場合、既に連携対象が存在しないことから、FD/ND番号ステータスは「廃止」となります。
          </p>
        </a-text>
      </div>
      <div v-if="cancelSoProcessingModal.screen === 6">
        <a-text :center="true">
          <p>上記FDND番号の廃止SOキャンセルを実施しました。</p>
        </a-text>
      </div>
      <template #footer>
        <a-button
          v-if="cancelSoProcessingModal.screen === 2"
          id="cancellingModalScreen2ApproveBtn"
          variant="block"
          color="primary"
          label="廃止"
          size="small"
          :disabled="isLoading"
          @click="approveCancelApplication(cancelSoProcessingModal.data, true)"
        />
        <a-button
          v-if="cancelSoProcessingModal.screen === 4"
          id="cancellingModalScreen4SOCancelBtn"
          variant="block"
          color="primary"
          label="SOキャンセル"
          size="small"
          :disabled="isLoading"
          @click="cancelSoProcessingModal.screen = 5"
        />
        <a-button
          v-if="cancelSoProcessingModal.screen === 5"
          id="cancellingModalScreen5SOCancelBtn"
          variant="block"
          color="primary"
          label="SOキャンセル"
          size="small"
          :disabled="isLoading"
          @click="cancelCancelApplication()"
        />
        <a-button
          id="cancellingModalCloseBtn"
          variant="outlined"
          color="primary"
          label="閉じる"
          size="small"
          :disabled="isLoading"
          @click="cancelSoProcessingModal.visible = false"
        />
      </template>
    </o-modal>
  </teleport>
  <!-- 利用中　モーダル -->
  <teleport to="body">
    <o-modal
      id="numberMgmt_cancelModal"
      :visible="cancelModal.visible"
      class="o-modal-remove-phone-number-confirmation t-number-mgmt"
      footer-variant="confirmation"
      width="395px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>
        <a-text color="orange" :center="true">
          <p>契約ID：{{ cancelModal.data.companyID }}</p>
          <p>FDND番号：{{ cancelModal.data.customerFDNDNumberView }}</p>
        </a-text>
      </template>
      <div v-if="cancelModal.screen === 0">
        <a-text :center="true">
          <p>
            上記番号が廃止対象番号であることを <br />
            確認してください。
          </p>
        </a-text>
        <a-text color="red" :center="true">
          <p>
            ※注意！<br />
            廃止対象のFDND番号であることを再度ご確認ください。
          </p>
        </a-text>
      </div>
      <div v-if="cancelModal.screen === 1">
        <a-text :center="true">
          <p>上記の「利用中」ステータスの番号を、<br />「廃止」ステータスとする場合は廃止ボタンを押下してください。</p>
        </a-text>
        <a-text color="red" :center="true">
          <p>
            ※注意！<br />
            FDND受付へ廃止申込された場合に、廃止処理を完了する為のウインドウです。
          </p>
        </a-text>
      </div>
      <div v-if="cancelModal.screen === 2">
        <a-text :center="true">
          <p>上記FDND番号の廃止登録を実施しました。</p>
        </a-text>
      </div>
      <template #footer>
        <a-button
          v-if="cancelModal.screen === 0"
          id="usingModalAbolitionBtn"
          variant="block"
          color="primary"
          label="廃止"
          size="small"
          :disabled="isLoading"
          @click="confirmFDNDCancelApplication(cancelModal.data, false)"
        />
        <a-button
          v-if="cancelModal.screen === 1"
          id="usingModalAbolitionBtn"
          variant="block"
          color="primary"
          label="廃止"
          size="small"
          :disabled="isLoading"
          @click="approveFDNDCancelApplication(cancelModal.data, false)"
        />
        <a-button
          id="usingModalCloseBtn"
          variant="outlined"
          color="primary"
          label="閉じる"
          size="small"
          :disabled="isLoading"
          @click="cancelModal.visible = false"
        />
      </template>
    </o-modal>
  </teleport>
  <!-- suspend 050 number modal -->
  <teleport to="body">
    <o-modal
      id="numberMgmt_suspend050NumberModal"
      v-model:visible="suspend050NumberModal.visible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-header="false"
    >
      <a-text id="numberMgmt_suspend050NumberId-text" color="orange" weight="bold" align="center">
        <h4>利用停止対象050番号：{{ suspend050NumberModal.selected050Number }}</h4>
      </a-text>
      <br />
      <a-text v-if="suspend050NumberModal.step === 1 || suspend050NumberModal.step === 2" align="center">
        <span>上記050番号を利用停止します。対象の番号であることを確認してから利用停止ボタンを押してください。</span>
      </a-text>
      <br />
      <a-text v-if="suspend050NumberModal.step === 2" align="center" color="red">
        <p>※注意！</p>
        <p>再度、利用停止対象であることを確認してください。</p>
      </a-text>
      <div v-if="suspend050NumberModal.step === 3">
        <a-text align="center">
          <span>上記050番号の利用停止処理が完了しました。</span>
        </a-text>
      </div>
      <template #footer>
        <a-button
          v-if="suspend050NumberModal.step === 1 || suspend050NumberModal.step === 2"
          id="suspend050NumberModalSuspendBtn"
          variant="block"
          color="primary"
          label="利用停止"
          size="small"
          :disabled="isLoading"
          @click="
            if (suspend050NumberModal.step === 1) {
              suspend050NumberModal.step = 2;
            } else {
              handleSuspend050Number();
            }
          "
        />
        <a-button
          v-if="suspend050NumberModal.step === 1 || suspend050NumberModal.step === 2"
          id="suspend050NumberModalCancelBtn"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          :disabled="isLoading"
          @click="suspend050NumberModal = {}"
        />
        <a-button
          v-if="suspend050NumberModal.step === 3"
          id="suspend050NumberModalOKBtn"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="suspend050NumberModal = {}"
        />
      </template>
    </o-modal>
  </teleport>
  <!-- reactive 050 number modal -->
  <teleport to="body">
    <o-modal
      id="numberMgmt_reactive050NumberModal"
      v-model:visible="reactive050NumberModal.visible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-header="false"
    >
      <a-text color="orange" weight="bold" align="center">
        <h4>利用停止解除対象050番号：{{ reactive050NumberModal.selected050Number }}</h4>
      </a-text>
      <br />
      <a-text v-if="reactive050NumberModal.step === 1 || reactive050NumberModal.step === 2" align="center">
        <span
          >上記050番号の利用停止解除を実施します。対象の番号であることを確認してから利用停止解除ボタンを押してください。</span
        >
      </a-text>
      <br />
      <a-text v-if="reactive050NumberModal.step === 2" align="center" color="red">
        <p>※注意！</p>
        <p>再度、利用停止解除対象であることを確認してください。</p>
      </a-text>
      <div v-if="reactive050NumberModal.step === 3">
        <a-text align="center">
          <span>上記050番号の利用停止解除処理が完了しました。</span>
        </a-text>
      </div>
      <template #footer>
        <a-button
          v-if="reactive050NumberModal.step === 1 || reactive050NumberModal.step === 2"
          id="reactive050NumberModalReactiveBtn"
          variant="block"
          color="primary"
          label="利用停止解除"
          size="small"
          :disabled="isLoading"
          @click="
            if (reactive050NumberModal.step === 1) {
              reactive050NumberModal.step = 2;
            } else {
              handleReactive050Number();
            }
          "
        />
        <a-button
          v-if="reactive050NumberModal.step === 1 || reactive050NumberModal.step === 2"
          id="reactive050NumberModalCancelBtn"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          :disabled="isLoading"
          @click="reactive050NumberModal = {}"
        />
        <a-button
          v-if="reactive050NumberModal.step === 3"
          id="reactive050NumberModalOKBtn"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="reactive050NumberModal = {}"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import ASelectField from '@/components/atoms/select-field';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';
import * as Handlebars from 'handlebars';
import MFilterDialog from '@/components/molecules/filter-dialog';

import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';
import { POINT } from '@/libs/constants';

export default {
  name: 't-number-mgmt',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    ASelectField,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
    MFilterDialog,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      currentPage: 1,
      parPage: 20,
      POINT,
      // 電話番号情報(表示用)
      numberList: [],
      // 電話番号ステータス一覧
      numberStatusName: {
        ready: '払い出し可能',
        allocated: '利用中',
        suspended: '利用停止',
        aging: 'エイジング期間',
        reserved: '割り当て処理中',
        deprecated: '払い出し不可',
      },
      fdndStatusName: {
        ready: '割り当て可能',
        allocated: '利用中',
        unavailable: '廃止',
      },
      fdndProcessStatusName: {
        'SO-Processing': '申し込み処理中',
        allocated: '利用中',
        'CancelSO-Processing': '廃止処理中',
        unavailable: '廃止',
      },
      fdndTypeName: {
        manually: '手動登録',
        automatically: 'システム払出',
      },
      fdndVisible: false,
      fdndEditViewMode: '',
      currentFdndNumber: '',
      previousFdndNumber: '',
      currentEditFdndType: '',
      noteVisible: false,
      currentNote: '',
      currentEditContentNumber: '',
      currentEditCompanyID: '',
      filter: {},
      filterColumn: '',
      filterSort: '',
      filterList: [],
      statusFilterDataList: [],
      fdndStatusFilterDataList: [],
      checkedStatus: [],
      checkedStatusFdnd: [],
      selectedService: 'ccc',
      serviceList: [
        {
          label: 'COTOHA Call Center',
          value: 'ccc',
        },
        {
          label: 'COTOHA Voice DX Basic (発信)',
          value: 'voicedx_outbound',
        },
        {
          label: 'COTOHA Voice DX Basic (着信)',
          value: 'voicedx_inbound',
        },
      ],
      currentSort: {},
      currentFilter: {},
      isLoadingNumberList: true,
      soProcessingModal: {
        data: {},
        visible: false,
      },
      cancelSoProcessingModal: {
        data: {},
        visible: false,
      },
      cancelModal: {
        data: {},
        visible: false,
      },
      isLoading: false,
      searchPhonenumber: '',
      numberListFull: [],
      suspend050NumberModal: {},
      reactive050NumberModal: {},
      allCompanyInfo: [],

      dataTableEmptyText: '',
      selMaxLength: '11',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-number-mgmt');
      return `${baseClassName} ${this.class}`.trim();
    },
    authInfo() {
      return this.$store.state.user.authInfo;
    },
    canDownloadCSV() {
      return this.authInfo !== 'operator';
    },
    canEditFDNDNumber() {
      return this.authInfo !== 'operator';
    },
    canEditRemarks() {
      return this.authInfo !== 'operator';
    },
    canOperateFDNDNumberStatus() {
      return this.authInfo !== 'operator';
    },
  },
  watch: {
    searchPhonenumber(val) {
      if (val === '') this.numberList = this.numberListFull;
    },
  },
  created() {
    if (this.companyID !== POINT) {
      this.$router.push({
        path: '/permission-denied',
      });
    }
  },
  async mounted() {
    if (this.companyID === POINT) {
      this.selectedCompanyID = POINT;
      this.fetchCompanyIDListHandler();
      await this.postRequest('/numbermgmt/getAllContractAdminName')
        .then(e => {
          if (e.status === 'success') {
            this.allCompanyInfo = e.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
    if (this.$route.query.companyID) {
      this.selectedCompanyID = this.$route.query.companyID;
    } else {
      await this.handlerGetNumberInfo(true);
    }
  },
  methods: {
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlist')
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.error(err);
          this.showErrorModal(messageContent.numbermgmtGetCompanyIdError);
        });
    },
    handlerGetNumberInfo: async function (initialize, sortInfo = null, filterInfo = null) {
      this.isLoadingNumberList = true;
      await this.postRequest('/numbermgmt/getlist', {
        companyID: this.$route.query.companyID,
        selectedService: this.selectedService,
      })
        .then(e => {
          let numberListArr = e.data;

          // ステータスを日本語表記に変換
          for (const numberInfo of numberListArr) {
            // 050番号ステータス
            if (this.numberStatusName[numberInfo.status]) {
              numberInfo.statusName = this.numberStatusName[numberInfo.status];
            } else {
              numberInfo.statusName = numberInfo.status;
            }
            // FDND番号のSOステータス
            if (this.fdndProcessStatusName[numberInfo.customerFDNDStatus]) {
              numberInfo.customerFDNDStatusName = this.fdndProcessStatusName[numberInfo.customerFDNDStatus];
            } else {
              numberInfo.customerFDNDStatusName = numberInfo.customerFDNDStatus;
            }
            // 契約者氏名を検索
            const currentCompanyInfo = this.allCompanyInfo.find(
              companyInfo => companyInfo.companyID === numberInfo.companyID
            );
            if (currentCompanyInfo) {
              numberInfo.adminName = currentCompanyInfo.adminName
                ? currentCompanyInfo.adminName.replace(/_/g, ' ')
                : '';
            } else {
              numberInfo.adminName = '';
            }
          }

          for (const numberInfo of numberListArr) {
            if (numberInfo.note) {
              // 備考の表示欄の10文字目以降を三点リーダに変換
              if (numberInfo.note.length > 10) {
                numberInfo.noteView = numberInfo.note.substring(0, 9) + '…';
              } else {
                numberInfo.noteView = numberInfo.note;
              }
            } else {
              numberInfo.noteView = '未設定';
            }
          }

          // 電話番号の+81を0に変換
          for (const numberInfo of numberListArr) {
            if (numberInfo.number) {
              numberInfo.numberView = numberInfo.number.replace('+81', '0');
            }
          }

          // FD/ND番号が空白の場合、「未設定」と表示
          for (const numberInfo of numberListArr) {
            if (numberInfo.customerFDNDNumber) {
              numberInfo.customerFDNDNumberView = numberInfo.customerFDNDNumber;
            } else {
              numberInfo.customerFDNDNumberView = '未設定';
            }
          }

          // undefinedのプロパティを空文字に変換
          numberListArr = this.checkNumberListProp(numberListArr);

          // 表示されているステータス名のフィルター項目を作成
          this.statusFilterDataList = this.getNumberStatusQueryList(numberListArr);
          this.fdndStatusFilterDataList = this.getFdndStatusQueryList(numberListArr);

          // 初期化フラグがtrueの場合はソート・フィルタ条件をクリア
          if (initialize === true) {
            this.currentSort = {};
            this.currentFilter = {};
            sortInfo = null;
            filterInfo = null;
          }

          // ソート・フィルターが指定されている場合
          if (sortInfo || filterInfo) {
            if (filterInfo) {
              let resultList = numberListArr;
              for (const prop in filterInfo) {
                if (filterInfo[prop].length > 0) {
                  resultList = resultList.filter(numberInfo => filterInfo[prop].includes(numberInfo[prop]));
                }
                // ダイアログを閉じる
                const columnIndex = this.getFilterColumnIndex(prop);
                if (columnIndex !== -1) {
                  this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
                }
              }
              // 検索結果が0件の場合
              if (resultList.length === 0) {
                this.dataTableEmptyText = messageContent.numbermgmtDataTableEmptyText;
              }
              numberListArr = resultList;
            }
            if (sortInfo) {
              if (sortInfo.dir === 'asc') {
                numberListArr.sort((a, b) => {
                  if (a[sortInfo.prop] < b[sortInfo.prop]) return -1;
                  if (a[sortInfo.prop] > b[sortInfo.prop]) return 1;
                  return 0;
                });
              } else if (sortInfo.dir === 'desc') {
                numberListArr.sort((a, b) => {
                  if (a[sortInfo.prop] > b[sortInfo.prop]) return -1;
                  if (a[sortInfo.prop] < b[sortInfo.prop]) return 1;
                  return 0;
                });
              }
              const columnIndex = this.getFilterColumnIndex(sortInfo.prop);
              if (columnIndex !== -1) {
                this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
              }
            }
          } else {
            // 選択済みステータスのフィルタをクリア
            this.$refs.statusFilter.handleClearClick();
            this.$refs.statusFilterFdnd.handleClearClick();
          }

          this.numberList = numberListArr;
          this.numberListFull = numberListArr;
          this.handleSearchPhonenumberClick();
          this.isLoadingNumberList = false;
        })
        .catch(() => {
          this.showErrorModal(messageContent.numbermgmtGetNumberError);
          this.isLoadingNumberList = false;
        });
    },
    handleSearchPhonenumberClick() {
      if (!this.searchPhonenumber) return;
      this.numberList = [];
      for (const item of this.numberListFull) {
        if (item.numberView && item.numberView.includes(this.searchPhonenumber)) {
          this.numberList.push(item);
        }
      }
    },
    // FDND番号の編集ボタン
    handleEditFdndNumberClick(telNumber, selectedCompanyID, fdndType) {
      if (!this.hasSpecialCharacterInString(this.currentFdndNumber)) {
        // 数値チェック
        if (!this.numberOnly(this.currentFdndNumber)) {
          this.showErrorModal(messageContent.numbermgmtFdndHalfError);
          return;
        }

        // 文字数チェック
        const lengthCheck = this.fdndNumberCheck({
          content: this.currentFdndNumber,
        });
        if (!lengthCheck.status) {
          this.showErrorModal(lengthCheck.message);
          return;
        }

        // 先頭に改行コードがあれば消去する
        while (this.currentFdndNumber.match(/^\n/)) {
          this.currentFdndNumber = this.currentFdndNumber.replace(/^\n/, '');
        }

        this.changedCurrentFdndNumber = this.currentFdndNumber.replace(/\n/g, '%%n%%');
        // FDND番号変更がない場合
        if (this.changedCurrentFdndNumber === this.previousFdndNumber) {
          this.handleCloseFdndEdit();
          return;
        }

        let sendData = {};
        if (this.changedCurrentFdndNumber !== '') {
          sendData = {
            customerFDNDNumber: this.changedCurrentFdndNumber,
          };
        } else {
          sendData = {
            customerFDNDNumber: '',
          };
        }

        this.postRequest('/numbermgmt/editFDNDNumber', {
          telNumber: telNumber,
          data: sendData,
          selectedService: this.selectedService,
          selectedCompanyID: selectedCompanyID,
        })
          .then(async e => {
            if (e.status) {
              // 新規登録
              if (this.previousFdndNumber === '') {
                this.postRequest('/numbermgmt/updateFdndNumber', {
                  data: { customerFDNDNumber: this.changedCurrentFdndNumber, type: 'manually', status: 'ready' },
                  selectedService: this.selectedService,
                  telNumber: telNumber,
                  selectedCompanyID: selectedCompanyID,
                })
                  .then(async e => {
                    if (e.status === 'success') {
                      //保存完了
                      this.fdndEditViewMode = 'completed';
                      await this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
                    } else {
                      this.showErrorModal(messageContent.numbermgmtFdndSaveError);
                    }
                  })
                  .catch(err => {
                    this.showErrorModal(messageContent.numbermgmtFdndSaveError);
                  });
              }
              // FDND番号を削除する場合
              else if (this.changedCurrentFdndNumber === '') {
                this.postRequest('/numbermgmt/deleteFdndNumber', {
                  selectedService: this.selectedService,
                  telNumber: telNumber,
                  selectedCompanyID: selectedCompanyID,
                  previousFdndNumber: this.previousFdndNumber,
                  fdndType: fdndType,
                })
                  .then(async e => {
                    if (e.status === 'success') {
                      //保存完了
                      this.fdndEditViewMode = 'completed';
                      await this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
                    } else {
                      this.showErrorModal(messageContent.numbermgmtFdndDeleteError);
                    }
                  })
                  .catch(err => {
                    this.showErrorModal(messageContent.numbermgmtFdndDeleteError);
                  });
              }
              // FDND番号変更
              else {
                await this.postRequest('/numbermgmt/deleteFdndNumber', {
                  selectedService: this.selectedService,
                  telNumber: telNumber,
                  selectedCompanyID: selectedCompanyID,
                  previousFdndNumber: this.previousFdndNumber,
                  fdndType: fdndType,
                }).catch(err => {
                  this.showErrorModal(messageContent.numbermgmtFdndPrevNumberDeleteError);
                });
                this.postRequest('/numbermgmt/updateFdndNumber', {
                  data: { customerFDNDNumber: this.changedCurrentFdndNumber, type: 'manually', status: 'ready' },
                  selectedService: this.selectedService,
                  telNumber: telNumber,
                  selectedCompanyID: selectedCompanyID,
                })
                  .then(async e => {
                    if (e.status === 'success') {
                      //保存完了
                      this.fdndEditViewMode = 'completed';
                      await this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
                    } else {
                      this.showErrorModal(messageContent.numbermgmtFdndSaveError);
                    }
                  })
                  .catch(err => {
                    this.showErrorModal(messageContent.numbermgmtFdndSaveError);
                  });
              }
            }
          })
          .catch(err => {
            this.showErrorModal(messageContent.numbermgmtFdndSaveError);
          });
      } else {
        this.showErrorModal(messageContent.hasSpecialCharacter);
      }
    },
    handleEditNoteClick(telNumber) {
      if (!this.hasSpecialCharacterInString(this.currentNote)) {
        // 文字数チェック
        const lengthCheck = this.maxlengthCheck({
          target: '備考',
          maxlength: 100,
          content: this.currentNote,
        });
        if (!lengthCheck.status) {
          this.showErrorModal(lengthCheck.message);
          return;
        }

        // 先頭に改行コードがあれば消去する
        while (this.currentNote.match(/^\n/)) {
          this.currentNote = this.currentNote.replace(/^\n/, '');
        }

        this.changedCurrentNote = this.currentNote.replace(/\n/g, '%%n%%');

        this.postRequest('/numbermgmt/setlist', {
          telNumber: telNumber,
          data: { note: this.changedCurrentNote },
          selectedService: this.selectedService,
        })
          .then(async e => {
            if (e.status) {
              //保存完了
              this.showInfoModal(messageContent.numbermgmtNoteSaveComplete);
              this.noteVisible = false;
              await this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
            }
          })
          .catch(err => {
            this.showErrorModal(messageContent.numbermgmtNoteSaveError);
          });
      } else {
        this.showErrorModal(messageContent.hasSpecialCharacter);
      }
    },
    handleSort(prop, dir) {
      this.currentSort = {
        prop: prop,
        dir: dir,
      };
      this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
    },
    getFilterColumnIndex(prop) {
      let columnIndex = -1;
      this.$refs.dataTable.columns.forEach((column, index) => {
        if (column.prop === prop) {
          columnIndex = index;
        }
      });
      return columnIndex;
    },
    // undefinedとなるプロバティに空文字を挿入(ソートを行うため)
    checkNumberListProp(list) {
      for (const obj of list) {
        if (!obj.companyID) {
          obj.companyID = '';
        }
        if (!obj.number) {
          obj.number = '';
        }
        if (!obj.numberView) {
          obj.numberView = '';
        }
        if (!obj.customerFDNDNumber) {
          obj.customerFDNDNumber = '';
        }
        if (!obj.customerFDNDNumberView) {
          obj.customerFDNDNumberView = '';
        }
        if (!obj.updateDate) {
          obj.updateDate = '';
        }
        if (!obj.status) {
          obj.status = '';
        }
        if (!obj.statusName) {
          obj.statusName = '';
        }
        if (!obj.note) {
          obj.note = '';
        }
        if (!obj.noteView) {
          obj.noteView = '';
        }
        if (!obj.customerFDNDType) {
          obj.customerFDNDType = '';
        }
        if (!obj.customerFDNDUpdateDate) {
          obj.customerFDNDUpdateDate = '';
        }
        if (!obj.customerFDNDStatusName) {
          obj.customerFDNDStatusName = '';
        }
      }
      return list;
    },
    handleFilterCancel(prop) {
      const columnIndex = this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
    },
    handleFilterConfirm(prop, selectedData, cnt) {
      this.currentFilter[prop] = selectedData;
      this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
    },
    getNumberStatusQueryList(list) {
      const labelList = [];
      const resultList = [];
      for (const obj of list) {
        if (obj.statusName) {
          labelList.push(obj.statusName);
        }
      }
      const queryList = Array.from(new Set(labelList));
      for (const labelText of queryList) {
        resultList.push({
          label: labelText,
          value: labelText,
        });
      }
      return resultList;
    },
    getFdndStatusQueryList(list) {
      const labelList = [];
      const resultList = [];
      for (const obj of list) {
        if (obj.customerFDNDStatusName) {
          labelList.push(obj.customerFDNDStatusName);
        }
      }
      const queryList = Array.from(new Set(labelList));
      for (const labelText of queryList) {
        resultList.push({
          label: labelText,
          value: labelText,
        });
      }
      return resultList;
    },
    handleDownloadClick() {
      try {
        let csvData =
          '契約ID,電話番号,FD/ND番号,050番号ステータス更新日,050番号ステータス,利用停止日,FD/ND番号ステータス更新日,FD/ND番号ステータス,備考\r\n';
        for (const numberInfo of this.numberList) {
          const currentLine =
            numberInfo.companyID +
            ',' +
            numberInfo.numberView +
            ',' +
            numberInfo.customerFDNDNumber +
            ',' +
            numberInfo.updateDate +
            ',' +
            numberInfo.statusName +
            ',' +
            numberInfo.suspendedDateStr +
            ',' +
            numberInfo.customerFDNDUpdateDate +
            ',' +
            numberInfo.customerFDNDStatusName +
            ',' +
            numberInfo.note +
            '\r\n';
          csvData += currentLine;
        }

        const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
        const blob = new Blob([bom, csvData], {
          type: 'text/plain',
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.download = 'phoneNumberList.csv';
        a.href = url;
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
        this.showErrorModal(messageContent.numbermgmtCsvDownloadError);
      }
    },
    fdndNumberCheck(params) {
      if (!params.content) {
        return { status: true };
      }
      if (params.content.startsWith('0120')) {
        if (params.content.length !== 10) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndCheck0120,
          };
        } else {
          return { status: true };
        }
      } else if (params.content.startsWith('0800')) {
        if (params.content.length !== 11) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndCheck0800,
          };
        } else {
          return { status: true };
        }
      } else if (params.content.startsWith('0570')) {
        if (params.content.length !== 10) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndCheck0570,
          };
        } else {
          return { status: true };
        }
      } else {
        return {
          status: false,
          message: messageContent.numbermgmtFdndCheckAll,
        };
      }
    },
    handleChangeFdndStatus(row) {
      const status = row.customerFDNDStatus;
      if (status === 'allocated') {
        // #3301 廃止のモーダル表示
        console.log('廃止モーダル表示');
        this.cancelModal = {
          visible: true,
          data: row,
          screen: 0,
        };
      } else if (status === 'SO-Processing') {
        // #3301 申し込み処理の完了確認モーダル表示
        console.log('申し込み処理の完了確認モーダル表示');
        this.soProcessingModal = {
          visible: true,
          data: row,
          screen: 1,
          csvDownloaded: false,
        };
      } else if (status === 'CancelSO-Processing') {
        // #3301 廃止処理の完了確認モーダル表示
        console.log('廃止処理の完了確認モーダル表示');
        this.cancelSoProcessingModal = {
          visible: true,
          data: row,
          screen: 1,
          csvDownloaded: false,
        };
      } else if (status === 'unavailable') {
        // 3301 050番号紐付けのモーダル表示
        console.log('050番号紐付けのモーダル表示');
      }
    },
    openFdndEditView(fdndNumber) {
      console.log(fdndNumber);
      if (fdndNumber) {
        this.fdndEditViewMode = 'edit';
        this.fdndVisible = true;
      } else {
        this.fdndEditViewMode = 'new';
        this.fdndVisible = true;
      }
    },
    handleCloseFdndEdit() {
      this.fdndVisible = false;
      this.fdndEditViewMode = '';
    },
    handleCloseNoteEdit() {
      this.noteVisible = false;
    },
    bzPortCsvDownload() {
      const data = {
        companyID: this.soProcessingModal.data.companyID,
        phonenumber: this.soProcessingModal.data.numberView,
        customerFDNDNumber: this.soProcessingModal.data.customerFDNDNumberView,
        selectedService: this.selectedService,
        status: 'applying',
      };
      this.postRequest('/numbermgmt/bzportcsvdownload', data)
        .then(res => {
          if (res.status === 'success') {
            this.soProcessingModal.csvDownloaded = true;
            this.exportCSV(res.data, res.filename);
          } else {
            throw new Error(res.status);
          }
        })
        .catch(err => {
          console.error(err);
          this.soProcessingModal.csvDownloaded = false;
          this.showErrorModal(messageContent.numbermgmtBzcsvDownloadError);
        });
    },
    exportCSV(csvData, filename) {
      let csvContent = '';
      for (const data of csvData) {
        const row = `="${data[0]}",="${data[1]}",="${data[2]}"\r\n`;
        csvContent += row;
      }

      // const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const bom = '\uFEFF\r\n';
      const blob = new Blob([bom, csvContent], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.download = filename;
      a.href = url;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
    cancelBzPortCsvDownload() {
      const data = {
        companyID: this.cancelSoProcessingModal.data.companyID,
        phonenumber: this.cancelSoProcessingModal.data.numberView,
        customerFDNDNumber: this.cancelSoProcessingModal.data.customerFDNDNumberView,
        status: 'cancelling',
        selectedService: this.selectedService,
      };
      this.postRequest('/numbermgmt/bzportcsvdownload', data)
        .then(res => {
          if (res.status === 'success') {
            this.cancelSoProcessingModal.csvDownloaded = true;
            this.exportCSV(res.data, res.filename);
          } else {
            throw new Error(res.status);
          }
        })
        .catch(err => {
          console.error(err);
          this.cancelSoProcessingModal.csvDownloaded = true;
          this.showErrorModal(messageContent.numbermgmtBzcsvDownloadError);
        });
    },
    // 開通ボタン
    approveApplication() {
      this.isLoading = true;
      const data = {
        companyID: this.soProcessingModal.data.companyID,
        phonenumber: this.soProcessingModal.data.numberView,
        customerFDNDNumber: this.soProcessingModal.data.customerFDNDNumberView,
        selectedService: this.selectedService,
      };
      this.postRequest('/numbermgmt/approveapplication', data)
        .then(res => {
          if (res.status === 'success') {
            this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
            this.isLoading = false;
            this.soProcessingModal.screen = 3;
          } else {
            throw new Error(res.status);
          }
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
          this.soProcessingModal.visible = false;
          this.showErrorModal(messageContent.numbermgmtFdndApproveError);
        });
    },
    // 申し込みのSOキャンセルボタン
    cancelApplication() {
      this.isLoading = true;
      const data = {
        companyID: this.soProcessingModal.data.companyID,
        phonenumber: this.soProcessingModal.data.numberView,
        customerFDNDNumber: this.soProcessingModal.data.customerFDNDNumberView,
        selectedService: this.selectedService,
      };
      this.postRequest('/numbermgmt/cancelapplication', data)
        .then(res => {
          if (res.status === 'success') {
            this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
            this.isLoading = false;
            this.soProcessingModal.screen = 6;
          } else {
            throw new Error(res.status);
          }
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
          this.soProcessingModal.visible = false;
          this.showErrorModal(messageContent.numbermgmtSoCancelError);
        });
    },
    // 廃止ボタン
    approveCancelApplication(paramData, mailFlag) {
      this.isLoading = true;
      const data = {
        companyID: paramData.companyID,
        phonenumber: paramData.numberView,
        customerFDNDNumber: paramData.customerFDNDNumberView,
        selectedService: this.selectedService,
        mailFlag: mailFlag,
      };
      this.postRequest('/numbermgmt/approveCancelApplication', data)
        .then(res => {
          if (res.status === 'success') {
            this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
            this.isLoading = false;
            this.cancelSoProcessingModal.screen = 3;
            this.cancelModal.visible = false;
          } else {
            throw new Error(res.status);
          }
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
          this.cancelSoProcessingModal.visible = false;
          this.cancelModal.visible = false;
          this.showErrorModal(messageContent.numbermgmtCancelError);
        });
    },
    // FNDN番号のステータスを使用中から廃止に更新

    confirmFDNDCancelApplication(paramData, mailFlag) {
      this.cancelModal.screen = 1;
    },

    approveFDNDCancelApplication(paramData, mailFlag) {
      this.isLoading = true;
      const data = {
        companyID: paramData.companyID,
        phonenumber: paramData.numberView,
        customerFDNDNumber: paramData.customerFDNDNumberView,
        selectedService: this.selectedService,
        mailFlag: mailFlag,
      };
      this.postRequest('/numbermgmt/approveCancelApplication', data)
        .then(res => {
          if (res.status === 'success') {
            this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
            this.isLoading = false;
            this.cancelModal.screen = 2;
          } else {
            throw new Error(res.status);
          }
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
          this.cancelModal.visible = false;
          this.showErrorModal(messageContent.numbermgmtCancelError);
        });
    },

    // 解約のSOキャンセルボタン
    cancelCancelApplication() {
      this.isLoading = true;
      const data = {
        companyID: this.cancelSoProcessingModal.data.companyID,
        phonenumber: this.cancelSoProcessingModal.data.numberView,
        customerFDNDNumber: this.cancelSoProcessingModal.data.customerFDNDNumberView,
        selectedService: this.selectedService,
      };
      this.postRequest('/numbermgmt/cancelCancelApplication', data)
        .then(res => {
          if (res.status === 'success') {
            this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
            this.isLoading = false;
            this.cancelSoProcessingModal.screen = 6;
          } else {
            throw new Error(res.status);
          }
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
          this.cancelSoProcessingModal.visible = false;
          this.showErrorModal(messageContent.numbermgmtSoCancelError);
        });
    },
    checkFdndNumberEditStatus(fdndType, fdndStatus) {
      if (this.selectedService === 'voicedx_outbound') {
        return false;
      } else {
        if (fdndType === 'manually') {
          return true;
        } else if (fdndType === 'automatically') {
          if (fdndStatus === 'unavailable') {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },
    handleSuspend050Number() {
      this.isLoading = true;
      const data = {
        companyID: this.suspend050NumberModal.companyID,
        phonenumber: this.suspend050NumberModal.selected050Number,
        selectedService: this.selectedService,
      };
      this.postRequest('/numbermgmt/suspend050Number', data)
        .then(res => {
          if (res.status === 'success') {
            this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
            this.isLoading = false;
            this.suspend050NumberModal.step = 3;
          } else {
            throw new Error(res.status);
          }
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
          this.suspend050NumberModal = {};
          this.showErrorModal('利用停止中にエラーが発生しました。時間を空けて再度実行してください。');
        });
    },
    handleReactive050Number() {
      this.isLoading = true;
      const data = {
        companyID: this.reactive050NumberModal.companyID,
        phonenumber: this.reactive050NumberModal.selected050Number,
        selectedService: this.selectedService,
      };
      this.postRequest('/numbermgmt/reactive050Number', data)
        .then(res => {
          if (res.status === 'success') {
            this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
            this.isLoading = false;
            this.reactive050NumberModal.step = 3;
          } else {
            throw new Error(res.status);
          }
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
          this.reactive050NumberModal = {};
          this.showErrorModal('利用停止解除中にエラーが発生しました。時間を空けて再度実行してください。');
        });
    },
    canSuspendOrReactive050Number(companyID) {
      if (this.companyID === POINT) {
        // 003300
        if (this.authInfo === 'soOperator') return false;
        if (this.authInfo === 'operator' && companyID === POINT) return false;
      } else {
        // 003300以外
        return false;
      }
      return true;
    },
  },
};
</script>
